import React from 'react';

interface TabPanelProps {
  children: React.ReactNode;
  value: string;
  index: string;
  className?: string;
}

const TabPanel: React.FC<TabPanelProps> = ({ children, value, index, className = '' }) => {
  const isActive = value === index;
  return (
    <div
      role="tabpanel"
      hidden={!isActive}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      className={className}
      style={!isActive ? { display: 'none' } : undefined}
    >
      {children}
    </div>
  );
};

export default TabPanel;
